export default __webpack_public_path__ + "static/bushes-da29eef080cd411b48120198ffe80d37.jpg";